import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=27c34159&"
import script from "./branch.vue?vue&type=script&lang=ts&"
export * from "./branch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports